// Global JS
// --

// Phone Number Text Animation
var phoneNumberSpan = $("#phoneNumber");
var phoneNumber = phoneNumberSpan.data("number");

if (phoneNumber !== undefined) {
  var phoneNumberList = phoneNumber.toString().split("");

  $.each(phoneNumberList, function(idx, elem) {
    // Create a span for the number and set opacity to 0
    var newEL = $("<span/>")
      .text(elem)
      .css({ opacity: 0 });

    // Append number to phone element
    newEL.appendTo(phoneNumberSpan);

    // Set delay for animation
    newEL.delay(idx * 70);

    // Animate opacity to full
    newEL.animate(
      {
        opacity: 1
      },
      5000
    );
  });
}

// Navigation "active" toggle
var currentPathName = location.pathname;
$(".navbar-custom li a").each(function() {
  var $this = $(this);
  if ($this.attr("href") === currentPathName) {
    $this.parent().addClass("active");
  }
});

// Tooltips - Initialize all
$(function() {
  $('[data-toggle="tooltip"]').tooltip();
});

// Disable autocomplete and paste in all input and textarea fields
document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('input, textarea');

  inputs.forEach(input => {
    input.setAttribute('autocomplete', 'off');

    input.addEventListener('paste', function (e) {
      e.preventDefault();
    });
  });
});